import React from 'react';
import { Alert, Button, Col } from 'antd';
import { Link } from 'react-router-dom';
import birthdayBalloons from "@assets/imgs/bth-day-balloons.png"


function BthDayMessage({ birthdayMessage }) {

  if (Object.keys(birthdayMessage).length)
    return (

      <div className='bthd-msg'>
        <div>
          <img src={birthdayBalloons} width={170} />
        </div>
        <div>
          <span className="bthd-msg-title">{birthdayMessage.title}</span>
          <div
            dangerouslySetInnerHTML={{ __html: birthdayMessage.message }}
            className='bthd-msg-body'
          ></div>
        </div>
      </div>

    );
}

export default BthDayMessage;